import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_HREF, trackCallConversion } from '../utils/phone';
const pageLinks = [{
  to: '/services',
  label: 'Services'
}, {
  to: '/about',
  label: 'About'
}, {
  to: '/specials',
  label: 'Specials'
}, {
  to: '/gallery',
  label: 'Gallery'
}, {
  to: '/reviews',
  label: 'Reviews'
}, {
  to: '/contact',
  label: 'Contact'
}, {
  to: '/faq',
  label: 'FAQ'
}];
const serviceLinks = [{
  to: '/full-detail',
  label: 'Full Detail'
}, {
  to: '/wash-wax',
  label: 'Wash & Wax'
}, {
  to: '/basic-wash',
  label: 'Basic Wash'
}, {
  to: '/services/interior-detailing',
  label: 'Interior Detailing'
}, {
  to: '/services/hybrid-ceramic-spray',
  label: 'Hybrid Ceramic Spray'
}, {
  to: '/services/headlight-restoration',
  label: 'Headlight Restoration'
}, {
  to: '/services/engine-bay-detailing',
  label: 'Engine Bay Detailing'
}];
const areaLinks = [['camarillo', 'Camarillo'], ['ventura', 'Ventura'], ['thousand-oaks', 'Thousand Oaks'], ['simi-valley', 'Simi Valley'], ['moorpark', 'Moorpark'], ['newbury-park', 'Newbury Park'], ['westlake-village', 'Westlake Village'], ['oak-park', 'Oak Park'], ['agoura-hills', 'Agoura Hills']];
export function SiteFooter() {
  return <footer className="w-full bg-zinc-950 border-t border-zinc-900 px-4 pt-14 pb-8 text-sm text-gray-400" data-id="element-534" data-mp="10rimwjm3tkeq">
      <div className="max-w-7xl mx-auto" data-id="element-535" data-mp="1ohmmmfw6900g">
        <div className="grid grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr] gap-x-8 gap-y-10" data-id="element-536" data-mp="1ohv4ynb2cxj1">
          <div className="col-span-2 lg:col-span-1" data-id="element-537" data-mp="1tf4sfxew6z48">
            <Link to="/" className="text-2xl font-black uppercase tracking-tight" data-id="element-538" data-mp="1ertdrmneyyzw">
              <span className="text-white" data-id="element-539" data-mp="1eppa95tfg205">Mike's</span>{' '}
              <span className="text-red-600" data-id="element-540" data-mp="1jp1z1w3uzj5d">Pro Detail</span>
            </Link>
            <p className="mt-1 text-gray-300 font-bold uppercase tracking-wider text-xs" data-id="element-541" data-mp="27f62o3h1riwd">
              Mobile Detailing
            </p>
            <p className="mt-4 max-w-xs leading-relaxed" data-id="element-542" data-mp="2c88plsrbju3l">
              Professional mobile car detailing throughout Ventura County and
              select surrounding areas. We come to your home, office, or
              anywhere convenient.
            </p>
            <a href={PHONE_HREF} onClick={trackCallConversion} className="mt-5 inline-flex items-center gap-3 text-white hover:text-yellow-400 transition-colors duration-150" data-id="element-543" data-mp="2d16l11qlzfln">
              <Phone className="w-5 h-5 text-red-500 shrink-0" aria-hidden="true" data-id="element-544" data-mp="233s7pazzf6xk" />
              <span data-id="element-545" data-mp="1ydbr5i0v756z">
                <span className="block text-xs uppercase tracking-wider text-gray-500 font-bold" data-id="element-546" data-mp="1yctljusbbeme">
                  Call or Text
                </span>
                <span className="text-xl font-black whitespace-nowrap" data-id="element-547" data-mp="1teifzw91vq9z">
                  {PHONE_DISPLAY}
                </span>
              </span>
            </a>
          </div>

          <FooterColumn title="Pages" links={pageLinks} data-id="element-548" data-mp="1kd0zicrqdmkr" />
          <FooterColumn title="Services" links={serviceLinks} data-id="element-549" data-mp="1fer01pyz3ztc" />
          <FooterColumn title="Service Areas" links={areaLinks.map(([slug, label]) => ({
          to: slug === 'thousand-oaks' ? '/mobile-detailing-thousand-oaks' : `/service-areas/${slug}`,
          label
        }))} data-id="element-550" data-mp="1fgkalgcpj46m" />
        </div>

        <div className="mt-12 pt-6 border-t border-zinc-900 flex flex-col md:flex-row justify-between gap-4 text-gray-500" data-id="element-551" data-mp="4u33l610r5m6">
          <p data-id="element-552" data-mp="8v6f5gc1afhl">
            © {new Date().getFullYear()} Mike's Pro Detail — Mobile Car
            Detailing in Ventura County, California. All rights reserved.
          </p>
          <ul className="flex flex-wrap gap-x-5 gap-y-2" data-id="element-553" data-mp="3d9wijgfpc914">
            <li data-id="element-554" data-mp="3d8bp5u54iw4u">
              <a href="https://share.google/k4UimfxXqCgBa74jP" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors duration-150" data-id="element-555" data-mp="3hc1a89mlavl4">
                Google Reviews
              </a>
            </li>
            <li data-id="element-556" data-mp="2plmzgm9vhzdo">
              <a href="https://www.bbb.org/search?find_text=Mike%27s+Pro+Detail&find_loc=Ventura+County%2C+CA" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors duration-150" data-id="element-557" data-mp="2pk24wwnk6gft">
                Better Business Bureau
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>;
}
function FooterColumn({
  title,
  links
}: {
  title: string;
  links: {
    to: string;
    label: string;
  }[];
}) {
  return <nav aria-label={`Footer ${title}`} data-id="element-558" data-mp="2fgn4sl21ia02">
      <h2 className="text-white font-bold uppercase tracking-wider text-xs mb-4" data-id="element-559" data-mp="2ffluwjwrftjx">
        {title}
      </h2>
      <ul className="space-y-2.5" data-id="element-560" data-mp="2taeepujonvwb">
        {links.map(link => <li key={link.to} data-id="element-561" data-mp="2o86xoqjzxpn4">
            <Link to={link.to} className="hover:text-yellow-400 transition-colors duration-150" data-id="element-562" data-mp="2o8yu23lf3reg">
              {link.label}
            </Link>
          </li>)}
      </ul>
    </nav>;
}